export default {
	benefit_types_index({ benefit_types_index }) {
		return benefit_types_index;
	},
};
